import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import clear1 from "../../assets/Images/Logo/clear1.jpg";
import clear2 from "../../assets/Images/Logo/clear2.jpg";

import cp1 from "../../assets/Images/cposter/1.png";
import cp2 from "../../assets/Images/cposter/2.png";

import ap1 from "../../assets/Images/pixelobs.jpg";
import ap2 from "../../assets/Images/catposter.png";
import ap3 from "../../assets/Images/posters/3dposter.png";
import ap4 from "../../assets/Images/posters/3D-poster-final.png";


import co1 from "../../assets/Images/progress/concept1.jpg";
import co2 from "../../assets/Images/progress/1.jpg";
import co3 from "../../assets/Images/progress/concept2.jpg";

import fac1 from "../../assets/Images/progress/fconcept.jpg";
import fac2 from "../../assets/Images/progress/fconcept2.GIF";
import fac3 from "../../assets/Images/progress/3d.mp4";
import fac4 from "../../assets/Images/progress/3d.png";












import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";






import Slideshow from "../../assets/Slideshow/Slideshow"; 





const Lo3Clear = () => {
    const navigate = useNavigate();
    const images = [clear1, clear2];
    const images2 = [cp1,cp2]
    const images3 = [ap1,ap2,ap3,ap4]
    const images4 = [co1,co2,co3]
    const images5 = [fac1,fac2,fac3,fac4]
  


    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo3-headings">
                <h1>Clear Starting Points</h1>
                <p>Document the first version of my idea clearly before iterating. </p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                        <BreadcrumbHeader />
            </div>

            <div className="content-lo3">
                <div className="content-lo3-clear">
                    <div className="content-lo3-clear-text">
                        <h1>Group Logo</h1>
                        <p>
                            After finalizing the concept for our logo, we began the creative process by
                            sketching multiple versions based on our shared vision. As a group we each contributed
                            our own logo, and then discussed what elements works best for our logo. After we reach a 
                            conclusion what we want as our logo, we move to the digital design phase.

                        </p>
                        <h2>Digitalizing the Design in Adobe Illustrator</h2>
                        <p>
                            After we are done with sketching, I translated the logo into a digital format using Adobe
                            Illustrator. I started by importing a photo of a sketch as aguide, then used vector tools and pen tool
                            too recreate the design accurately. 
                        </p>
                        
                    </div>

                    <div className="content-lo3-clear-text2">
                        <h1>Concept Posters for the client</h1>
                        <p>
                            For the concept poster, My group and I did the same strategy which was to create our own version of the poster,
                            this gave us multiple starting points to compare and discuss. After reviewing each design, we selected the strongest 
                            elements from each and combine them into a finalized version.
                             
                        </p>
                        <h2>Using Figma to collaborate</h2>
                        <p>
                            Figma made the design process smooth and efficient. We were able to work on the same file, leave comments, and
                            make live adjustments during our discussions. It also allowed us to compare layouts side by side, which helped
                            us decide what to keep, change, or improve in the final poster.
                        </p>
                        
                    </div>

                    <div className="content-lo3-clear-text3">
                        <h1>Actual Poster product</h1>
                        <p>
                            After finalizing the concept, I created the actual poster for the campaign based on our chosen theme: cat memes.
                            Since the campaign was promoting the Virtual Production minor, I designed the poster to include playful cat elements
                            while still maintaining a clear connection to the tech and creative aspects of virtual production.
                        </p>
                        <h2>Using Assets from Pixel Playground</h2>
                        <p>
                            During our observation session at the Pixel Playground, I gathered useful visual assets, including photos and textures
                            that could reflect the environment and vibe of virtual production. One of the photos I took during the visit became the
                            base for my poster design. I edited this image in Adobe Illustrator, incorporating it into the layout while blending it
                            with humorous cat visuals to stay true to our campaign theme.
                        </p>

                        
                        
                    </div>

                    <div className="content-lo3-clear-text4">
                        <h1>3D Cat Mascot</h1>
                        <h2>Idea Sparked by Feedback</h2>
                        <p>
                            During our campaign presentation, our mentor Jan suggested that we could add a mascot to support the theme. This idea inspired me to start thinking about how a cat mascot could make the campaign more engaging and memorable.
                        </p>
                        <h2>Sketching the Concept</h2>
                        <p>
                            I sketched the first version of the mascot based on our cat meme theme. I focused on a simple design that would connect the mascot to our campaign theme but, at the end I used one of my group mate sketch to create this 3D model.
    
                        </p>
                        <h2>Researching Low Poly Style</h2>
                        <p>
                            To prepare for modeling in Blender, I did a small research on how to make a low poly characters. This style was perfect for our concept, because personally I think that with a pixelated mascot I could connect it better with our client studio
                            which is the Pixel Playground, and other than that I also think that it will be easeier to turn it into a 3D model.
                        </p>

                        
                        
                    </div>

                    <div className="content-lo3-clear-text5">
                        <h1>3D Face Model</h1>
                        <h2>Feedback That Started The Idea</h2>
                        <p>
                            The idea to include a 3D face model came from a suggestion by my teacher, Amer, who encouraged me to add something interactive to make my homepage more unique and personal. This feedback became the starting point for the project.
                        </p>
                        <h2>Sketching The First Concept</h2>
                        <p>
                            Before jumping into 3D modeling, I began by sketching on Procreate to get a rough idea of how the face should look and behave.
                        </p>
                        <h2>Keeping Up With Current Technology</h2>
                        <p>
                            To make the process more efficient and realistic, I used a LiDAR camera to scan my own face. This gave me a basic 3D structure that I could work from and helped save time in the sculpting process.
                        </p>
                        <h2>Bringing It to Blender</h2>
                        <p>
                            Once I had the 3D scan, I imported it into Blender to begin refining and shaping the model. This marked the end of the planning phase and the start of development, with a clear base and goal already in place.
                        </p>
                        
                        
                    </div>

                    <div className="content-lo3-clear-slideshow">
                        <Slideshow images={images} />

                    </div>

                    <div className="content-lo3-clear-slideshow2">
                        <Slideshow images={images2} />

                    </div>

                    <div className="content-lo3-clear-slideshow3">
                        <Slideshow images={images3} />

                    </div>


                    <div className="content-lo3-clear-slideshow4">
                        <Slideshow images={images4} />

                    </div>

                    <div className="content-lo3-clear-slideshow5">
                        <Slideshow images={images5} />

                    </div>
                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo3Clear;